/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { LastEditedList } from '../../models/last-edited-list';

export interface LastEditedGetNewDocumentList$Params {
}

export function lastEditedGetNewDocumentList(http: HttpClient, rootUrl: string, params?: LastEditedGetNewDocumentList$Params, context?: HttpContext): Observable<StrictHttpResponse<LastEditedList>> {
  const rb = new RequestBuilder(rootUrl, lastEditedGetNewDocumentList.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<LastEditedList>;
    })
  );
}

lastEditedGetNewDocumentList.PATH = '/last-edited/list';
